import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getSEOConfig } from '../config/seoConfig';

class ScrollToTop extends Component {
    closeMobileNavbar() {
        // Close mobile navbar on route change
        const dom = document.getElementById('navbar');
        if (dom) dom.className = 'navmenu navbar-collapse collapse';
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
            this.closeMobileNavbar();
        }
    }

    componentDidMount() {
        this.closeMobileNavbar();
    }

    render() {
        const { title, description, keywords, canonical } = getSEOConfig(this.props.location.pathname);
        return (
            <>
                <Helmet>
                    <title>{title}</title>
                    <meta name="description" content={description} />
                    <meta name="keywords" content={keywords} />
                    {canonical && <link rel="canonical" href={canonical} />}
                </Helmet>
                {this.props.children}
            </>
        );
    }
}

export default withRouter(ScrollToTop);
